import { lazy, Suspense } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";

type SubscribeFormVariant = "default" | "compact" | "minimal";

// Lazy load to avoid circular import issues
const InlineSubscribeForm = lazy(() =>
  import("@/components/InlineSubscribeForm").then((module) => ({
    default: module.InlineSubscribeForm,
  }))
);

interface SubscribeDialogProps {
  children: React.ReactElement;
  title?: string;
  description?: string;
  formVariant?: SubscribeFormVariant;
  formButtonText?: string;
  contentClassName?: string;
}

export function SubscribeDialog({
  children,
  title = "Subscribe to Snake Signals",
  description = "Get weekly Python hiring market intelligence delivered to your inbox.",
  formVariant = "compact",
  formButtonText = "Subscribe",
  contentClassName = "sm:max-w-md",
}: SubscribeDialogProps) {
  return (
    <Dialog>
      <DialogTrigger asChild>{children}</DialogTrigger>
      <DialogContent className={contentClassName}>
        <DialogHeader>
          <DialogTitle className="font-orbitron">{title}</DialogTitle>
        </DialogHeader>
        {description ? (
          <p className="text-sm text-muted-foreground mb-4">{description}</p>
        ) : null}
        <Suspense
          fallback={<div className="h-12 animate-pulse bg-muted rounded" />}
        >
          <InlineSubscribeForm variant={formVariant} buttonText={formButtonText} />
        </Suspense>
      </DialogContent>
    </Dialog>
  );
}
